import {
	vh,
	startTypeShuffle,
	utils,
	startWhichSizeVideo,
	whichSizeVideo,
	toggleModalSketch,
	scrubVideoOnScroll,
	countdownTimer
} from "../components/utils";
import {gsapContext} from "../components/theme-scripts";

export function templateCoCreationInit() {

	const section2Panel0 = document.querySelector('.section-2__panel--0');
	const section2Panel0Toggle = section2Panel0.querySelector('.circle-toggle');
	const section3Panel0 = document.querySelector('.section-3__panel--0');
	const section3Panel1 = document.querySelector('.section-3__panel--1');
	const section3Panel2 = document.querySelector('.section-3__panel--2');
	const section4Panel0 = document.querySelector('.section-4__panel--0');
	const section5Panel0 = document.querySelector('.section-5__panel--0');

	gsapContext.add(() => {

		ScrollTrigger.create({
			trigger:     section2Panel0,
			start:       () => 'top 50%',
			end:         () => 'bottom 10%',
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section2Panel0);

				startWhichSizeVideo(section2Panel0);
			},
			onLeave:     () => {
				section2Panel0.classList.remove('trigger-2', 'trigger-3');
			},
			onLeaveBack: () => {
				section2Panel0.classList.remove('trigger-2', 'trigger-3');
			},
			onToggle:    ({progress, direction, isActive}) => {
				toggleModalSketch(section2Panel0, isActive);
			},
			//markers:  true
		});

		section2Panel0Toggle.addEventListener('click', function () {
			if (section2Panel0.classList.contains('trigger-1'))
			{
				utils.toggleClasses(section2Panel0, 'trigger-1', 'trigger-2');
			}
			else if (section2Panel0.classList.contains('trigger-2'))
			{
				utils.toggleClasses(section2Panel0, 'trigger-2', 'trigger-3');
			}
			else if (section2Panel0.classList.contains('trigger-3'))
			{
				utils.toggleClasses(section2Panel0, 'trigger-3', 'trigger-1');
			}
		});


		let panels = gsap.utils.toArray('.section-3__panel');

		/**
		 * Animations for section-3
		 */
		gsap.to(panels, {
			ease:          'none',
			scrollTrigger: {
				trigger: '.section-3',
				pin:     true,
				scrub:   0.1,
				end:     () => '+=' + vh(1000), // total length of .section-1 = 1150vh
				//markers: true
			}
		});

		/**
		 * Animations for section-3__panel--0
		 */
		ScrollTrigger.create({
			trigger:     section3Panel0,
			start:       () => 'top top',
			end:         () => '+=' + vh(125),
			toggleClass: 'trigger-1',
			onEnter:     () => {

				startTypeShuffle(section3Panel0);
			},
			//markers:     true
		});

		/**
		 * Animations for section-3__panel--1
		 */
		gsap.to(section3Panel1, {
			left:          0,
			ease:          'none',
			scrollTrigger: {
				trigger: section3Panel1,
				start:   () => 'top+=' + vh(100) + ' top',
				end:     () => '+=' + vh(100),
				scrub:   1,
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});

		gsap.timeline({
			scrollTrigger: {
				trigger: section3Panel1,
				start:   () => 'top+=' + vh(300) + ' top',
				end:     () => '+=' + vh(100),
				scrub:   1,
				//markers: true
			}
		})
			.to(section3Panel0, {
				opacity: 0,
				ease:    'none',
			})
			.to(section3Panel1, {
				opacity: 0,
				scale:   2,
				ease:    'none',
			}, "<");


		let videoCoCreation = document.getElementById('video-co-creation');

		if (videoCoCreation !== null)
		{
			whichSizeVideo(videoCoCreation);

			let videoScrollTrigger = {
				trigger: section3Panel2,
				start:   () => 'top+=' + vh(400) + ' top',
				end:     () => '+=' + vh(600),
				scrub:   2,
				//markers: true
			};
			scrubVideoOnScroll(videoCoCreation, videoScrollTrigger);
		}

		gsap.timeline({
			scrollTrigger: {
				trigger: section3Panel2,
				start:   () => 'top+=' + vh(400) + ' top',
				end:     () => '+=' + vh(600),
				scrub:   2,
				//markers: true
			}
		})
			.to(section3Panel2.querySelector('strong'), {
				duration: 12,
				opacity:  1,
				ease:     'none',
				repeat:   1,
				yoyo:     true
			})
			.to(section3Panel2.querySelector('.text-1'), {
				duration: 18,
				opacity:  1,
				ease:     'none',
				repeat:   1,
				yoyo:     true
			})
			.to({}, {duration: 27})
			.from(section3Panel2.querySelectorAll('li'), {
				duration:   20,
				translateX: 100,
				opacity:    0,
				ease:       'none',
				stagger:    3
			})
			.to({}, {duration: 23});


		/**
		 * Animations for section-4__panel--0
		 */
		ScrollTrigger.create({
			trigger:     section4Panel0,
			start:       () => 'top 50%',
			end:         () => 'bottom top',
			toggleClass: 'trigger-1',
			onEnter:     () => {

				startTypeShuffle(section4Panel0);
			},
			//markers:     true
		});


		/**
		 * Animations for section-5__panel--0
		 */
		ScrollTrigger.create({
			trigger:     section5Panel0,
			start:       () => 'top 50%',
			end:         () => 'bottom top',
			toggleClass: 'trigger-1',
			onEnter:     () => {

				startTypeShuffle(section5Panel0);
			},
			//markers:     true
		});


		/**
		 * ON RESIZE END
		 */

		// do something when the window resizing ends
		window.addEventListener('resizeEnd', function () {

			if (videoCoCreation !== null)
			{
				whichSizeVideo(videoCoCreation);
			}
		});



		let countdowns = document.querySelectorAll('.countdown');

		countdowns.forEach((el) => {
			countdownTimer(el.getAttribute('data-date'), el);
		});


		const reveal = document.querySelector('#image-reveal');
		const follower = document.querySelector('.reveal-follower');
		const followerWidth = follower.clientWidth;
		const followerHeight = follower.clientHeight;

		function moveReveal(e) {
			e.preventDefault();
			let shiftup = 0;
			if (e.type === "touchmove")
			{
				shiftup = followerHeight/* * window.devicePixelRatio*/;
				e = e.touches[0];
			}
			const pos = reveal.getBoundingClientRect();
			const dx = pos.left + window.scrollX;
			const dy = pos.top + window.scrollY + shiftup;
			follower.style.left = (e.pageX - dx - followerWidth / 2) + "px";
			follower.style.top = (e.pageY - dy - followerHeight / 2) + "px";
			follower.style["background-position-x"] = pos.left + "px";
			follower.style["background-position-y"] = pos.top + "px";
			follower.style["background-size"] = pos.width + "px";
		}

		reveal.addEventListener('mousemove', moveReveal);
		reveal.addEventListener('touchmove', moveReveal);
	});

	document.querySelector('.btn[data-popup="register-popup"]').addEventListener('click', function () {
		openNebulaAndLogin();
	})
}